var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web_box"},[_c('iframe',{attrs:{"src":"https://app.aijhealth.com/dayi/client/rules.html?type=2","frameborder":"0"}})])
}]

export { render, staticRenderFns }